export const LOCAL_STORAGE_KEYS = {
    CMS_USER: "tc.lm.cms.user",
    ACCESS_TOKEN: "tc.lm.access_token",
    LM_USER: "tc.lm.csm.userdata"
}